import { useHistory, useLocation } from 'react-router';
import { BigCalendar } from 'lib/ui';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import { STAFF_CALENDAR_MAX_HEIGHT } from 'utils/constants/calendar';
import { localizer } from 'utils/builders/calendar';
import { EditAvailabilityWrap } from './EditAvailability.style';
import Header from 'views/containers/header';
import { useCallback, useState, useEffect } from 'react';
import {
  addMinutes,
  checkIfLessThanFifteenMinsAndUpdate,
  durationInMinutes,
  handleDroppedEvent,
  handleLowerTouchingEvents,
  handleUpperTouchingEvents,
  removeAllOverlappingEventsWithEditedOneAndAddNewEvent,
  removeOverlappingEvents
} from 'pages/ConfigurationsPage/addAvailabilityTemplate/availabilityTemplateCalender/utils';
import { ClientAvailabilityEvent } from 'model/v2/availabilityTemplate';
import { ContentWrapper } from 'views/components/ui/card/card.style';
import EditAvailabilityBlockForm from './forms/EditAvailabilityBlockForm';
import ModalSemantic from 'components/modalSemantic';
import { Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import IsBookedBlockAuditModal from 'components/calendar/planner/PlannerModals/IsBookedBlockAuditModal';
import Content from 'views/components/ui/content';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { GET_CLIENT_LOCATIONS } from 'api/graphql/v2/queries/Enums';
import { CalendarWrapper } from 'pages/ConfigurationsPage/addAvailabilityTemplate/style';
import { getLocationColor } from 'pages/ConfigurationsPage/addAvailabilityTemplate/utils';
import {
  GET_AVAILABILITY_AUDIT,
  SAVE_CLIENT_AVAILABILITY
} from 'api/graphql/v2/mutations/ClientAvailability';
import {
  compareInitalandUpdatedSlots,
  mapClientAvailabilityOutputToEvents,
  mapClientEventsToClientAvailabilityInput
} from 'helpers/clientAvailabilityHelperV2';
import {
  GET_CLIENT_AVAILABILITYV2,
  GET_SHIFT_DROPDOWN_OPTIONS
} from 'api/graphql/v2/queries/Clients';
import {
  ClientAvailabilityOutput,
  ClientDayAvailabilityOutput,
  IBlock,
  ISchedulingShiftDropdownOptions
} from 'model/v2';
import { SCROLL_TIME_CALENDAR } from 'utils/constants/calendar';
import { CLIENT_LOCATIONS_DATA } from 'utils/constants/lists';
import { IAvailabilityAudit, IAvailabilityEvent } from 'model/event';
import moment from 'moment';
import Expand from '../../../../../assets/img/Expand.png';
import { AvailabilityModalWarning } from 'views/components/calendar/mainCalendar/modalWarning';
import Warning from '../../../../../assets/img/Warning.png';
import React from 'react';
import { ClientBlockAvailabilityEvent } from 'model/v2/availabilityTemplate';

const EditClientAvailability: React.FC = () => {
  const history = useHistory();
  const location = useLocation<any>();
  const { client } = location.state;
  const view = 'week';
  const DragAndDropCalendar = withDragAndDrop(BigCalendar);
  const [events, setEvents] = useState<ClientAvailabilityEvent[]>([]);
  const [editModal, setEditModal] = useState(false);
  const [auditAvailabilityId, setAuditAvailabilityId] = useState<
    number | null
  >(null);
  const [selectedEvent, setSelectedEvent] = useState<ClientAvailabilityEvent>();
  const [initialSlots, setInitialSlots] = useState<ClientAvailabilityEvent[]>(
    []
  );
  const [addedEvent, setAddedEvent] = useState<
    ClientAvailabilityEvent | undefined
  >(undefined);
  const [deletPopupWarning, setDeletPopupWarning] = useState<boolean>(false);
  const [availabilityAudit, setAvailabilityAudit] = useState<
    { baseLimit: number; auditHistory: IAvailabilityAudit[] | [] } | undefined
  >();
  const [isProcessing, setIsProcessing] = useState<Boolean>(false);
  const [locationChecked, setLocationChecked] = useState<number>(0);
  const [blockLocationChecked, setBlockLocationChecked] = useState<number>(7);
  const [selectedBlock, setSelectedBlock] = useState<string[]>([]);

  const onShiftSubmit = useCallback(
    (
      data: ClientBlockAvailabilityEvent,
      submittedEvent: ClientAvailabilityEvent,
      schedulingShiftsData: ISchedulingShiftDropdownOptions[]
    ) => {
      onEditModalClose();
      if (addedEvent) setAddedEvent(undefined);
      let idx = -1;
      if (submittedEvent.id) {
        idx = events.findIndex(event => event.id === submittedEvent.id);
      }

      if (idx > -1) {
        setEvents((prev: ClientAvailabilityEvent[]) => {
          let newEvents = prev;
          newEvents = newEvents.map(event => {
            if (event.blockId === submittedEvent.blockId) {
              return {
                ...event,
                location: data.location
              };
            }
            return event;
          });
          return [...newEvents];
        });
      } else {
        const blocksMap = schedulingShiftsData
          .flatMap(shift => shift.blocks)
          .reduce((acc: Record<string, IBlock>, block) => {
            if (block.id != null) {
              acc[block.id.toString()] = block;
            }
            return acc;
          }, {});

        const blockAvailability: ClientDayAvailabilityOutput[] = [];
        data.blocks.forEach(block => {
          const blockData = blocksMap[block.toString()];
          if (
            blockData.days &&
            blockData.startTime &&
            blockData.endTime &&
            blockData.id != null
          ) {
            blockData.days.forEach((day: number) => {
              if (!blockData.startTime || !blockData.endTime) {
                console.warn('Block is missing time data', blockData);
                return;
              }

              blockAvailability.push({
                id: submittedEvent.id,
                dayOfWeek: day,
                location: data.location,
                startTime: blockData.startTime,
                endTime: blockData.endTime,
                blockId: blockData.id
              });
            });
          }
        });

        let mappedAvailabilitySlot = mapClientAvailabilityOutputToEvents(
          blockAvailability
        );
        let generalEvents = events.filter(e => !e.blockId);

        const followUpGeneralEvents: ClientAvailabilityEvent[] = [];

        mappedAvailabilitySlot.forEach(blockEvent => {
          const originalEvent = generalEvents.find(
            e =>
              e.start.getDay() === blockEvent.start.getDay() &&
              e.start <= blockEvent.start &&
              e.end > blockEvent.end
          );

          removeOverlappingEvents(blockEvent, generalEvents);
          handleDroppedEvent(blockEvent, generalEvents);
          handleUpperTouchingEvents(blockEvent, generalEvents);
          handleLowerTouchingEvents(blockEvent, generalEvents);

          if (originalEvent && originalEvent.end > blockEvent.end) {
            followUpGeneralEvents.push({
              start: blockEvent.end,
              end: originalEvent.end,
              title: '',
              location: originalEvent.location
            });
          }

          // Add new general event after block (e.g., 30 min)
          const blockEnd = moment(blockEvent.end);
          const newStart = blockEnd.clone();
          const newEnd = blockEnd.clone().add(90, 'minutes');

          // Optional limit: don't extend past 8 PM
          if (newEnd.hour() < 20) {
            followUpGeneralEvents.push({
              start: newStart.toDate(),
              end: newEnd.toDate(),
              title: '',
              location: blockEvent.location
            });
          }
        });

        const generalIds = new Set(generalEvents.map(e => e.id));
        const preserved = events.filter(e => e.blockId || generalIds.has(e.id));
        const finalEvents = [...preserved, ...mappedAvailabilitySlot];

        setEvents(finalEvents);
      }

      setEditModal(false);
    },
    [addedEvent, events]
  );

  const { data: locations, loading: loadingLocations, error } = useQuery(
    GET_CLIENT_LOCATIONS
  );

  const { data: availabilityData, loading: loadingEvents } = useQuery<
    ClientAvailabilityOutput
  >(GET_CLIENT_AVAILABILITYV2, {
    fetchPolicy: 'no-cache',
    variables: { id: client.id },
    onCompleted: data => {
      let mappedAvailabilitySlot = mapClientAvailabilityOutputToEvents(
        data?.clientDayAvailabilities
      );
      setEvents(mappedAvailabilitySlot);
    }
  });

  useEffect(() => {
    if (
      availabilityData?.clientDayAvailabilities &&
      initialSlots.length === 0
    ) {
      let mappedAvailabilitySlot = mapClientAvailabilityOutputToEvents(
        availabilityData.clientDayAvailabilities
      );
      setInitialSlots(mappedAvailabilitySlot);
    }
  }, [availabilityData, initialSlots.length]);

  const {
    data: schedulingBlocks,
    loading: isSchedulingBlocksLoading
  } = useQuery(GET_SHIFT_DROPDOWN_OPTIONS);

  const schedulingShiftsData = schedulingBlocks?.getShiftDropdownOptions;
  useQuery(GET_AVAILABILITY_AUDIT, {
    fetchPolicy: 'no-cache',
    variables: { clientId: client.id },
    onCompleted: data => {
      setAvailabilityAudit({
        baseLimit: 3,
        auditHistory: data.getAvailabilityAudit.map(
          (auditData: IAvailabilityAudit) => {
            return {
              actionBy: auditData.actionBy,
              actionAt: moment(auditData.actionAt).format('MM/DD/YYYY'),
              actionTime: moment(auditData.actionAt).format('hh:mm a')
            };
          }
        )
      });
    }
  });

  const [saveTemplate] = useMutation(SAVE_CLIENT_AVAILABILITY);

  const formats = {
    dayFormat: 'ddd'
  };

  const customEventPropGetter = useCallback(
    (event: any) => {
      const locationData = [
        ...CLIENT_LOCATIONS_DATA,
        ...(locations?.clientLocations || [])
      ];
      const style = getLocationColor(locationData, event.location);
      if (event.blockId) {
        style.backgroundColor = 'rgba(244, 30, 7, 0.2)';
        style.border = 'rgba(61, 182, 132, 0.2)';
      } else {
        style.backgroundColor = 'rgba(61, 137, 182, 0.2)';
        style.border = 'rgba(61, 137, 182, 0.2)';
      }
      return {
        style
      };
    },
    [locations]
  );

  const titleAccessor = useCallback(
    (event: IAvailabilityEvent) => {
      let locationTypeArr: string[] = [];
      locations?.clientLocations.map(
        (location: { id: number; title: string }) => {
          if ((location.id & event.location!) > 0)
            locationTypeArr.push(location.title);
        }
      );

      return event.title?.toLocaleLowerCase() || locationTypeArr.join(', ');
    },
    [locations]
  );
  const EventComponent = (event: any) => {
    const eventStartTime = moment(event.event.start);
    const eventEndTime = moment(event.event.end);
    const differenceInMinutes = eventEndTime.diff(eventStartTime, 'minutes');
    let locationTypeArr: string[] = [];
    locations?.clientLocations.map(
      (location: { id: number; title: string }) => {
        if ((location.id & event.event.location!) > 0) {
          locationTypeArr.push(location.title);
        }
      }
    );

    let transformedArray = locationTypeArr.map((element: string) => {
      switch (element) {
        case 'In Clinic':
          return 'In-clinic';
        case 'Offsite':
          return 'Off-Site';
        default:
          return element;
      }
    });
    if (differenceInMinutes < 45 && transformedArray.length > 0)
      transformedArray = ['...'];
    else if (differenceInMinutes < 45 && transformedArray.length <= 0)
      transformedArray = [''];
    else if (differenceInMinutes < 60 && transformedArray.length > 1)
      transformedArray = [`${transformedArray[0]}...`];
    else if (differenceInMinutes < 90 && transformedArray.length > 2)
      transformedArray = [
        `${transformedArray[0]}`,
        `${transformedArray[1]}...`
      ];

    const blockAvailabilityId = Number(event.event?.id);
    const showAuditIcon =
      !!event.event?.blockId && Number.isFinite(blockAvailabilityId);

    // Attach NATIVE listeners directly on the button node. React delegates
    // onClick to the root, so RBC's event-selection fires before a React
    // stopPropagation can run. A native listener on the button itself fires at
    // the target first, so we can stop the event before it reaches RBC and open
    // the audit modal reliably.
    const bindAuditButton = (node: HTMLButtonElement | null) => {
      if (!node || (node as any).__auditBound) return;
      (node as any).__auditBound = true;
      const stop = (ev: Event) => {
        ev.stopPropagation();
        if ((ev as any).stopImmediatePropagation) {
          (ev as any).stopImmediatePropagation();
        }
      };
      node.addEventListener('mousedown', stop);
      node.addEventListener('mouseup', stop);
      node.addEventListener('click', (ev: Event) => {
        stop(ev);
        const id = Number(node.getAttribute('data-audit-availability-id'));
        if (Number.isFinite(id)) setAuditAvailabilityId(id);
      });
    };

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {showAuditIcon && (
          <Tooltip title="View isBookedBlock audit">
            <button
              type="button"
              ref={bindAuditButton}
              className="audit-history-btn"
              data-audit-availability-id={blockAvailabilityId}
            >
              <ClockCircleOutlined className="audit-history-icon" />
            </button>
          </Tooltip>
        )}
        {transformedArray.map((locationType: any) => {
          return (
            <div className="location-container">
              <span>{locationType}</span>
            </div>
          );
        })}
      </div>
    );
  };

  const onDelete = useCallback(() => {
    history.goBack();
  }, [setEvents, events]);

  const resizeEvent = useCallback(
    ({ event, start, end }: any) => {
      // Don't allow resizing block events
      if (event.blockId) return;

      const indexOfNewEvent = events.indexOf(event);
      const updatedEvent = {
        ...event,
        start,
        end
      };

      // Check if the resized event would overlap with any block events
      const blockEvents = events.filter(e => e.blockId);
      const wouldOverlapWithBlock = blockEvents.some(blockEvent => {
        return (
          updatedEvent.start.getDate() === blockEvent.start.getDate() &&
          updatedEvent.start.getTime() < blockEvent.end.getTime() &&
          updatedEvent.end.getTime() > blockEvent.start.getTime()
        );
      });

      // If it would overlap with block events, don't allow the resize
      if (wouldOverlapWithBlock) return;

      checkIfLessThanFifteenMinsAndUpdate(updatedEvent);
      events.splice(indexOfNewEvent, 1, updatedEvent);

      // Only apply overlapping logic to general events, not block events
      const generalEvents = events.filter(e => !e.blockId);
      removeOverlappingEvents(updatedEvent, generalEvents);
      handleUpperTouchingEvents(updatedEvent, generalEvents);
      handleLowerTouchingEvents(updatedEvent, generalEvents);

      // Reconstruct the events array with block events preserved
      const finalEvents = [...generalEvents, ...blockEvents];
      setEvents(finalEvents);
    },
    [setEvents, events]
  );

  const moveEvent = useCallback(
    ({ event, start, end }: any) => {
      // Don't allow moving block events
      if (event.blockId) return;

      const idx = events.indexOf(event);
      const updatedEvent = {
        ...event,
        start,
        end
      };

      // Check if the moved event would overlap with any block events
      const blockEvents = events.filter(e => e.blockId);
      const wouldOverlapWithBlock = blockEvents.some(blockEvent => {
        return (
          updatedEvent.start.getDate() === blockEvent.start.getDate() &&
          updatedEvent.start.getTime() < blockEvent.end.getTime() &&
          updatedEvent.end.getTime() > blockEvent.start.getTime()
        );
      });

      // If it would overlap with block events, don't allow the move
      if (wouldOverlapWithBlock) return;

      events.splice(idx, 1, updatedEvent);

      // Only apply overlapping logic to general events, not block events
      const generalEvents = events.filter(e => !e.blockId);
      removeOverlappingEvents(updatedEvent, generalEvents);
      handleDroppedEvent(updatedEvent, generalEvents);
      handleUpperTouchingEvents(updatedEvent, generalEvents);
      handleLowerTouchingEvents(updatedEvent, generalEvents);

      // Reconstruct the events array with block events preserved
      const finalEvents = [...generalEvents, ...blockEvents];
      setEvents(finalEvents);
    },
    [events, setEvents]
  );

  const onEventClick = useCallback(
    (event: any) => {
      setSelectedEvent(event);
      setLocationChecked(event.location);
      setEditModal(true);
    },
    [locationChecked]
  );

  const createNewEvent = useCallback(
    (start: Date, end: Date) => {
      if (durationInMinutes(end, start) < 30) {
        end = addMinutes(end, 15);
      }
      const event: ClientAvailabilityEvent = {
        end: end,
        start: start,
        title: '',
        location: locations?.clientLocations[0].id
      };

      // Check if the new event would overlap with any block events
      const blockEvents = events.filter(e => e.blockId);
      const wouldOverlapWithBlock = blockEvents.some(blockEvent => {
        return (
          event.start.getDate() === blockEvent.start.getDate() &&
          event.start.getTime() < blockEvent.end.getTime() &&
          event.end.getTime() > blockEvent.start.getTime()
        );
      });

      // If it would overlap with block events, don't create the event
      if (wouldOverlapWithBlock) return;

      setEvents((prev: ClientAvailabilityEvent[]) => {
        let newEvents = prev;
        setAddedEvent(event);
        newEvents.push(event);
        return [...newEvents];
      });
      onEventClick(event);
    },
    [locations, onEventClick, setEvents, events]
  );

  const onCalenderClick = useCallback(
    ({ start, end }) => {
      console.log('onCalenderClick', start, end);
      createNewEvent(start, end);
    },
    [createNewEvent]
  );

  const onEditModalClose = useCallback(() => {
    if (addedEvent) {
      setEvents((prev: ClientAvailabilityEvent[]) => {
        let newEvents = prev;
        const idx = newEvents.indexOf(addedEvent);
        if (idx > -1) {
          newEvents.splice(idx, 1);
          setAddedEvent(undefined);
        }
        return [...newEvents];
      });
    }
    setDeletPopupWarning(false);
    setEditModal(false);
    setBlockLocationChecked(7);
    setSelectedBlock([]);
  }, [addedEvent]);

  const onEditModalSubmit = useCallback(
    (data: any, submittedEvent: ClientAvailabilityEvent) => {
      if (addedEvent) setAddedEvent(undefined);
      const idx = events.indexOf(submittedEvent);

      if (idx > -1) {
        const updatedEvent: ClientAvailabilityEvent = {
          id: submittedEvent.id,
          title: '',
          location: data.location,
          start: data.start,
          end: data.end
        };
        events.splice(idx, 1, updatedEvent);
      } else {
        events.push(submittedEvent);
      }

      // Separate block events from general events
      const blockEvents = events.filter(e => e.blockId);
      const generalEvents = events.filter(e => !e.blockId);

      data.recurringDays.forEach((day: number) => {
        removeAllOverlappingEventsWithEditedOneAndAddNewEvent(
          generalEvents,
          data,
          day,
          new Date()
        );
      });

      // Reconstruct the events array with block events preserved
      const finalEvents = [...generalEvents, ...blockEvents];
      setEvents(finalEvents);
      setEditModal(false);
    },
    [addedEvent, events]
  );

  const onEditDelete = useCallback(
    (selectedEvent: ClientAvailabilityEvent) => {
      if (selectedEvent.blockId) {
        setEvents((prev: ClientAvailabilityEvent[]) => {
          let newEvents = prev;
          newEvents = newEvents.filter(
            event => event.blockId !== selectedEvent.blockId
          );
          setAddedEvent(undefined);
          return [...newEvents];
        });
        setBlockLocationChecked(7);
        setSelectedBlock([]);
      } else {
        const idx = events.indexOf(selectedEvent);

        setEvents((prev: ClientAvailabilityEvent[]) => {
          let newEvents = prev;
          setAddedEvent(undefined);
          newEvents.splice(idx, 1);
          return [...newEvents];
        });
      }
      setEditModal(false);
    },
    [setEvents, events]
  );

  const hasChanges = useCallback(() => {
    return compareInitalandUpdatedSlots(initialSlots, events);
  }, [initialSlots, events]);

  const goBack = useCallback(
    (isSaved?: boolean) => {
      const isSlotsUpdated = compareInitalandUpdatedSlots(initialSlots, events);
      if (isSlotsUpdated || isSaved) {
        history.goBack();
      } else {
        setDeletPopupWarning(true);
      }
    },
    [history, hasChanges]
  );

  const onSaveButton = useCallback(() => {
    setIsProcessing(true);
    saveTemplate({
      variables: {
        clientAvailability: mapClientEventsToClientAvailabilityInput(
          client.id,
          events
        )
      }
    })
      .then(() => {
        goBack(true);
      })
      .catch((e: any) => {
        setIsProcessing(false);
        console.log(e);
      });
  }, [client, events, goBack, saveTemplate]);
  const checkIfAuditExist = () => {
    if (availabilityAudit) {
      if (
        availabilityAudit['auditHistory'].length > 0 &&
        availabilityAudit['auditHistory'].length > 3
      )
        return true;
      else return false;
    } else return false;
  };
  const CustomHeader = (label: any) => {
    const labelday = label.label.replace(/[0-9]/g, '');
    const labeldate = label.label.replace(/[A-Za-z]/g, '');
    const displayDay = ['Sun'];
    return (
      <div>
        <div
          className={displayDay.includes(labelday) ? 'weekendDay' : ''}
          style={{ textAlign: 'center', fontSize: '15px', fontWeight: 700 }}
        >
          <u>{labelday}</u>
          <span>{labeldate}</span>
        </div>
        <div className="clinic-abbr">
          <span>
            {displayDay.includes(labelday) ? '' : client?.clinic?.abbreviation}
          </span>
        </div>
      </div>
    );
  };

  return (
    <Content
      loading={loadingEvents || loadingLocations}
      error={error}
      data={locations}
      fullHeight={true}
    >
      {() => (
        <>
          <EditAvailabilityWrap>
            <Header
              title="Edit Availability"
              source={client}
              buttonText="Save Changes"
              handleSubmit={onSaveButton}
              onCancel={goBack}
              loading={isProcessing}
              disabled={isProcessing || !hasChanges()}
              newAppointment={undefined}
            />
            <div className="inner-wrap">
              <div className="calendar-actions">
                <h2 className="sideBarTitle">RECURRING AVAILABILITY </h2>
                {availabilityAudit && (
                  <div className="audit-inner-label">
                    <p>Last updated by:</p>
                    {availabilityAudit['auditHistory']
                      .filter(
                        (
                          filtredAuditData: IAvailabilityAudit,
                          index: number
                        ) => {
                          return (
                            filtredAuditData &&
                            index < availabilityAudit.baseLimit
                          );
                        }
                      )
                      .map((auditData: IAvailabilityAudit, index: number) => {
                        return (
                          <div key={index}>
                            <p
                              title={`${auditData.actionBy},${auditData.actionAt} ${auditData.actionTime}`}
                              className={'Audit-content'}
                            >
                              {auditData.actionBy}, {'\u00A0'}
                              {auditData.actionAt} {'\u00A0'}
                              {auditData.actionTime}
                            </p>
                          </div>
                        );
                      })}
                  </div>
                )}
                {checkIfAuditExist() &&
                  availabilityAudit?.baseLimit! <
                    availabilityAudit?.auditHistory.length! && (
                    <div className="audit-show-label">
                      <div
                        onClick={() => {
                          setAvailabilityAudit((prevState: any) => ({
                            ...prevState,
                            baseLimit: prevState['baseLimit'] + 3
                          }));
                        }}
                      >
                        <p>Show more</p>
                      </div>
                      <img
                        className="expand-icon"
                        src={Expand}
                        alt="expand-button"
                        onClick={() => {
                          setAvailabilityAudit((prevState: any) => ({
                            ...prevState,
                            baseLimit: prevState['baseLimit'] + 3
                          }));
                        }}
                      />
                    </div>
                  )}
                {checkIfAuditExist() &&
                  availabilityAudit?.baseLimit! >=
                    availabilityAudit?.auditHistory.length! && (
                    <div className="audit-show-label">
                      <div
                        onClick={() => {
                          setAvailabilityAudit((prevState: any) => ({
                            ...prevState,
                            baseLimit: 3
                          }));
                        }}
                      >
                        <p>Show less</p>
                      </div>
                      <img
                        className="expand-icon"
                        src={Expand}
                        style={{ transform: 'rotate(-180deg)' }}
                        alt="expand-button"
                        onClick={() => {
                          setAvailabilityAudit((prevState: any) => ({
                            ...prevState,
                            baseLimit: 3
                          }));
                        }}
                      />
                    </div>
                  )}
              </div>

              <CalendarWrapper>
                <DragAndDropCalendar
                  selectable
                  views={[view]}
                  defaultView={view}
                  defaultDate={new Date()}
                  toolbar={false}
                  scrollToTime={SCROLL_TIME_CALENDAR}
                  events={events}
                  step={15}
                  timeslots={4}
                  localizer={localizer}
                  formats={formats}
                  style={{
                    height: STAFF_CALENDAR_MAX_HEIGHT
                  }}
                  titleAccessor={titleAccessor}
                  components={{
                    event: EventComponent,
                    header: CustomHeader
                  }}
                  eventPropGetter={customEventPropGetter}
                  onEventResize={resizeEvent}
                  onEventDrop={moveEvent}
                  onSelectEvent={onEventClick}
                  onSelectSlot={onCalenderClick}
                  resizable
                  resizableAccessor={(event: any) => !event.blockId}
                  className="Client-edit-avail"
                />
              </CalendarWrapper>
            </div>
          </EditAvailabilityWrap>
          {editModal && (
            <ContentWrapper>
              <ModalSemantic
                open={true}
                onClose={onEditModalClose}
                modalWidth={550}
                title={'Edit Availability Block'}
                trigger={<div></div>}
                content={
                  <EditAvailabilityBlockForm
                    onClose={onEditModalClose}
                    onSubmit={onEditModalSubmit}
                    onDelete={onEditDelete}
                    locations={locations.clientLocations}
                    data={selectedEvent}
                    setLocationChecked={setLocationChecked}
                    locationChecked={locationChecked}
                    setBlockLocationChecked={setBlockLocationChecked}
                    blockLocationChecked={blockLocationChecked}
                    setSelectedBlock={setSelectedBlock}
                    selectedBlock={selectedBlock}
                    schedulingShiftsData={schedulingShiftsData}
                    isSchedulingBlocksLoading={isSchedulingBlocksLoading}
                    onShiftSubmit={onShiftSubmit}
                  />
                }
              />
            </ContentWrapper>
          )}

          {auditAvailabilityId != null && (
            <IsBookedBlockAuditModal
              isOpen={true}
              onClose={() => setAuditAvailabilityId(null)}
              availabilityId={auditAvailabilityId}
              variant="client"
            />
          )}
          {deletPopupWarning && (
            <ContentWrapper>
              <ModalSemantic
                open={true}
                onClose={onEditModalClose}
                modalWidth={550}
                title={'Warning'}
                img={Warning}
                trigger={<div></div>}
                content={
                  <AvailabilityModalWarning
                    data={selectedEvent}
                    onClose={onEditModalClose}
                    onDelete={onDelete}
                    onSubmit={onEditModalSubmit}
                  />
                }
              />
            </ContentWrapper>
          )}
        </>
      )}
    </Content>
  );
};

export default EditClientAvailability;
